// extracted by mini-css-extract-plugin
export default {"cls1":"HApfX9hvcMvxg0vSAXLL","cls2":"QCmSCedgjwthw0IvxAn7 HApfX9hvcMvxg0vSAXLL"};